import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

export const login = async (email, password) => {
  // 1. Try sponsor login first
  try {
    const sponsorRes = await axios.post(`${API_BASE_URL}/sponsor/login`, { email, password });
    if (sponsorRes.data?.result?.token) {
      return sponsorRes.data.result;
    }
  } catch (sponsorErr) {
    const status = sponsorErr.response?.status;
    if (status !== 401 && status !== 404 && status !== 422) {
      throw new Error(sponsorErr.response?.data?.message || 'Login failed');
    }
  }

  // 2. Fall back to tutor login (super admin, club admin, tutor/mentor)
  let tutorRes;
  try {
    tutorRes = await axios.post(`${API_BASE_URL}/tutor/login`, { email, password });
  } catch (tutorErr) {
    throw new Error(tutorErr.response?.data?.message || 'Invalid email or password');
  }

  if (!tutorRes.data?.result?.token) {
    throw new Error('Login failed');
  }

  return tutorRes.data.result;
};

// Called when careers app detects ?sso_token= in URL (coming from control centre)
// The token is the existing control centre JWT — we just validate and use it directly
export const loginWithSSOToken = (ssoToken) => {
  // Token is already a valid signed JWT from the same backend
  // Just return it in the expected shape — AuthContext will decode and store it
  return { token: ssoToken, refreshToken: null, user: null };
};

export const refreshToken = async () => {
  const stored = localStorage.getItem('careers_refresh_token');
  if (!stored) throw new Error('No refresh token');

  const user = JSON.parse(localStorage.getItem('careers_user') || '{}');
  const endpoint = user.role === 'sponsor'
    ? `${API_BASE_URL}/sponsor/refresh-token`
    : `${API_BASE_URL}/tutor/refresh-token`;

  const res = await axios.post(endpoint, {}, {
    headers: { Authorization: stored },
  });

  return res.data.result;
};

export const logout = async () => {
  const token = localStorage.getItem('careers_token');
  if (!token) return;
  const user = JSON.parse(localStorage.getItem('careers_user') || '{}');
  try {
    const endpoint = user.role === 'sponsor'
      ? `${API_BASE_URL}/sponsor/logout`
      : `${API_BASE_URL}/tutor/logout`;
    await axios.get(endpoint, { headers: { Authorization: token } });
  } catch {
    // Clear locally regardless
  }
};
